import React from "react";
import { Observer } from "mobx-react";
import { Typography } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { FormxDebugger } from "@components/formx";
import { useContractsPriceTemplatesForm } from "./useContractsPriceTemplatesForm";
import { Form } from "@modules/formx-react";
import { Spinner, TabBadge } from "@common";
import { ErrorBoundary } from "@components/error-boundary";
import { TabFormLayout } from "@common/forms/TabFormLayout";

import { ContractsPriceTemplateEditorForm } from "@config_editor/ContractsPriceTemplates/ContractsPriceEditorForm";
import { ContractPriceTemplateFormInput } from "@config_editor/ContractsPriceTemplates/ContractsPriceTemplateFormInput";

type Props = {
  id: string;
};

export function ContractsPriceTemplateEditor({ id }: Props) {
  const {
    formStore,
    addBlankRecord,
    duplicateRecord,
    loading,
    validationResult,
    navigation
  } = useContractsPriceTemplatesForm(id);

  if (loading) {
    return <Spinner />;
  }

  return (
    <ErrorBoundary>
      <Form store={formStore} allowUpdates>
        <FormxDebugger store={formStore} />
        <div>
          <Observer>
            {() => (
              <TabFormLayout
                blockId="contract_price_template_form"
                canSubmit={formStore.canSubmit}
                isDirty={formStore.dirty}
                isSubmitting={formStore.isSubmitting}
                onSubmit={formStore.submit}
                onReset={() => formStore.reset()}
                onClose={navigation.close}
                tabs={[
                  {
                    label: <TabBadge label={locale.General} hasErrors={false} />,
                    value: "general",
                    content: () => (
                      <ContractsPriceTemplateEditorForm<ContractPriceTemplateFormInput>
                        formStore={formStore}
                        loading={loading}
                        addBlankRecord={addBlankRecord}
                        duplicateRecord={duplicateRecord}
                        name={"records"}
                        holidaysName={"highHolidays"}
                        validationResult={validationResult}
                      />
                    )
                  }
                ]}
                topbarProps={{
                  children: (
                    <Observer>
                      {() => (
                        <Typography variant="h6">{formStore.values.name}</Typography>
                      )}
                    </Observer>
                  )
                }}
              />
            )}
          </Observer>
        </div>
      </Form>
    </ErrorBoundary>
  );
}
